/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { CIO_PURPLE, LIGHTER_GRAY_COLOR } from 'cio/utils/colors';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';

interface CohortSliderArgs {
  value: string;
  min?: number;
  max?: number;
  step?: number;
  type?: string;
  onChange: (value: string) => unknown;
}

export default class CohortSlider extends Component<CohortSliderArgs> {
  get min() {
    return this.args.min ?? 1;
  }

  get max() {
    return this.args.max ?? 100;
  }

  get step() {
    return this.args.step ?? 1;
  }

  get type() {
    return this.args.type ?? 'range';
  }

  get style() {
    let baseline = Math.ceil(((parseInt(this.args.value) - this.min) / (this.max - this.min)) * 100);

    return htmlSafe(
      `background-image: linear-gradient(to right, ${CIO_PURPLE} ${baseline}%, ${LIGHTER_GRAY_COLOR} ${baseline}%, ${LIGHTER_GRAY_COLOR} 100%)`,
    );
  }

  @action
  onInput(event: FlyKeyboardEvent<HTMLInputElement>) {
    this.args.onChange(event.target.value);
  }
}
